import { __exportAll } from "../_virtual/_rolldown/runtime.js";
import { UniversalTime } from "@biteinc/helpers-universal";
//#region src/utils/open_hours_override_utils.ts
var open_hours_override_utils_exports = /* @__PURE__ */ __exportAll({ isActiveAt: () => isActiveAt });
function isActiveAt(data, time) {
	const fromTimestamp = data.date + UniversalTime.dayTimestampFromScheduleBoundary(data.schedule.from);
	let toTimestamp = data.date + UniversalTime.dayTimestampFromScheduleBoundary(data.schedule.to);
	if (toTimestamp <= fromTimestamp) toTimestamp += UniversalTime.DAY;
	return fromTimestamp <= time && time < toTimestamp;
}
//#endregion
export { isActiveAt, open_hours_override_utils_exports };

//# sourceMappingURL=open_hours_override_utils.js.map